import {get, put} from '@iflat/iflat-ui/src/api/methods'
import {post} from "@iflat-ui/api/methods";

export const USER_ACTIONS = {
  TOUR_FINISH: 'tourFinish'
}

export default {
  async getMe (params) {
    const res = await get(`/users/me`, {params})
    return res.data
  },
  async updateItem(id, data) {
    const res = await put(`/users/${id}`, data)
    return res.data
  },
  async sendAction(id, action, data) {
    const res = await post(`/users/${id}/actions`, {action, data})
    return res.data
  }
}